/**
 * Utility functions for creating SVG fill patterns
 */

export type FillPattern = 'solid' | 'lines' | 'cross';

/**
 * Get pattern properties for SVG pattern definition
 * @param pattern - Type of pattern to generate
 * @returns Pattern configuration object
 */
export function getPatternConfig(pattern: FillPattern) {
  const strokeWidth = 1;
  const spacing = 8;

  switch (pattern) {
    case 'solid':
      return null; // No pattern needed for solid fills

    case 'lines':
      return {
        width: spacing,
        height: spacing,
        patternTransform: 'rotate(45)',
        elements: [
          {
            type: 'line',
            x1: 0,
            y1: spacing / 2,
            x2: spacing,
            y2: spacing / 2,
            strokeWidth,
            opacity: 0.6,
          },
        ],
      };

    case 'cross':
      return {
        width: spacing,
        height: spacing,
        patternTransform: '',
        elements: [
          {
            type: 'line',
            x1: 0,
            y1: spacing / 2,
            x2: spacing,
            y2: spacing / 2,
            strokeWidth,
            opacity: 0.6,
          },
          {
            type: 'line',
            x1: spacing / 2,
            y1: 0,
            x2: spacing / 2,
            y2: spacing,
            strokeWidth,
            opacity: 0.6,
          },
        ],
      };

    default:
      return null;
  }
}

/**
 * Get the fill value for SVG elements based on pattern
 * @param color - Fill color
 * @param pattern - Fill pattern type
 * @param patternId - Unique pattern ID
 * @returns SVG fill value
 */
export function getFillValue(
  color: string,
  pattern: FillPattern,
  patternId: string
): string {
  if (color === 'transparent') {
    return 'transparent';
  }

  switch (pattern) {
    case 'solid':
      return color;
    case 'lines':
    case 'cross':
      return `url(#${patternId})`;
    default:
      return color;
  }
}
